export const TOTAL_STEPS = 3

export const FORM_TEXTS = {
	title: 'Crear cuenta',
	subtitle: 'Cargá los datos para completar el registro',
	mobileTitle: 'Registro',
	buttons: {
		continue: 'Continuar',
		register: 'Registrarme',
		cancel: 'Cancelar',
		back: 'Volver'
	},
	labels: {
		name: 'Nombre',
		lastName: 'Apellido',
		email: 'Email',
		repeatEmail: 'Confirmá tu email',
		birthDate: 'Fecha de nacimiento',
		gender: 'Sexo',
		documentType: 'Tipo de documento',
		documentNumber: 'Número de documento',
		healthInsurance: 'Obra social o prepaga',
		plan: 'Plan',
		credentialNumber: 'Número de credencial',
		phoneNumber: 'Número de teléfono (Opcional)'
	},
	placeholders: {
		name: 'Ingresá tu nombre',
		lastName: 'Ingresá tu apellido',
		email: 'Ingresá tu email',
		repeatEmail: 'Confirmá tu email',
		birthDate: 'DD/MM/AAAA',
		gender: 'Seleccioná tu sexo',
		documentType: 'Seleccioná tu tipo de documento',
		documentNumber: 'Ingresá tu número de documento',
		healthInsurance: 'Seleccioná tu obra social o prepaga',
		plan: 'Seleccioná tu plan',
		credentialNumber: 'Ingresá tu número de credencial',
		phoneNumber: 'Ingresá tu número de teléfono'
	}
}

export const MOCK_GENDERS = [
	{ id: 'M', valueText: 'Masculino' },
	{ id: 'F', valueText: 'Femenino' },
	{ id: 'X', valueText: 'Otro' }
]

export const MOCK_DOCUMENT_TYPES = [
	{ id: '0', valueText: 'DNI' },
	{ id: '1', valueText: 'CI' },
	{ id: '2', valueText: 'LC' },
	{ id: '3', valueText: 'LE' },
	{ id: '5', valueText: 'PA' }
]

export const MOCK_HEALTH_INSURANCES = [
	{ codigo: 2072192, descripcion: '21%FUNDUS S.A' },
	{ codigo: 2072307, descripcion: 'GALENO' },
	{ codigo: 2073009, descripcion: 'OSDE' },
	{ codigo: 2072176, descripcion: 'OMINT' },
	{ codigo: 2072552, descripcion: 'SWISS MEDICAL' },
	{ codigo: 2072812, descripcion: 'PAMI' },
	{ codigo: 2072502, descripcion: 'ACCION MEDICA' },
	{ codigo: 2072892, descripcion: 'ACTIVA SALUD' },
	{ codigo: 2072613, descripcion: 'IOMA' },
	{ codigo: 2072615, descripcion: 'SANCOR' }
]

export const MOCK_PLANS = [
	{ codigo: 2074315, descripcion: '025 (1004)' },
	{ codigo: 2074214, descripcion: '110 (1004)' },
	{ codigo: 2075799, descripcion: '210 (1004)' },
	{ codigo: 2073108, descripcion: '310 (1004)' },
	{ codigo: 2073356, descripcion: '410 (1004)' },
	{ codigo: 2073151, descripcion: '420 (1004)' },
	{ codigo: 2073596, descripcion: '450 (1004)' },
	{ codigo: 2074969, descripcion: '510 (1004)' },
	{ codigo: 5421440, descripcion: '6 210' },
	{ codigo: 5421441, descripcion: '6 310' },
	{ codigo: 4998062, descripcion: '6030' },
	{ codigo: 5472148, descripcion: '7 700' },
	{ codigo: 2073233, descripcion: 'GENERICO' }
]
